// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2wTh0","list":"styles_list__3wTmR"};